import React from 'react';
import homeIcon from "../home.svg";
import {LocationSearchBox} from "@ongov/location-react-components/src/components";
import {searchBoxCatIdDev} from "./constants";
import {pageCategory} from "data/lib/utils/constants";

export function getSearchBox(): { searchBoxIds: string[], searchBoxes: { [key: string]: JSX.Element[] } } {

  let searchBoxes: { [key: string]: JSX.Element[] } = {}
  let searchCats: { page: string; category: string }[]
  let searchBoxIds = [searchBoxCatIdDev]

  const categories = [...pageCategory]

  // Gather all search boxes to show for development and staging envs
  if (process.env.NODE_ENV === "development" ||
      window.location.pathname === "/locations/employment-training/search-box") {

    searchBoxes[searchBoxCatIdDev] = categories.map((cat) =>
        <div key={`container-${cat.category}`}>
          <span children={`${cat.category}`}/>
          <LocationSearchBox key={cat.category}
                             headingTransKey={cat.page}
                             customLocationIcon={homeIcon}
                             searchParams={new URLSearchParams({page: cat.page})}/>
        </div>
    )

    return {searchBoxIds, searchBoxes}
  }

  searchCats = categories.filter(cat => (document.getElementById(cat.category)))

  searchBoxes = searchCats.reduce((accm, cat) =>
      Object.assign(accm, {
        [cat.category]: [<LocationSearchBox
            key={cat.category}
            headingTransKey={cat.page}
            customLocationIcon={homeIcon}
            searchParams={new URLSearchParams({page: cat.page})}/>]
      }), {})

  searchBoxIds = searchCats.map((c) => c.category)

  return {searchBoxIds, searchBoxes}

}